<template>
  <div class="ToIntoFail">
      <div class="TransferFailed_box">
        <CustomHead srcName="success.png">
          <div class="TransferFailed">￥{{Account || ''}}</div>
          <div class="TransferFailed_tip">{{retMsg || ''}}成功</div>
        </CustomHead>
      </div>
    <FooterTwoButton left="返回我的融资" right="再转一笔" :leftNext="leftNext" :rightNext="rightNext"></FooterTwoButton>
  </div>
</template>
<script>
import FooterTwoButton from '@/components/FooterTwoButton.vue';
import CustomHead from '@/components/CustomHead.vue';

export default {
  name: 'ToIntoFail',
  data() {
    return {
      Account: this.$router.currentRoute.query.amount,
      isText: this.$router.currentRoute.query.isText,
    };
  },
  components: {
    FooterTwoButton,
    CustomHead,
  },
  methods: {
    leftNext() {
      this.$router.push('/supermarket/v2/myload');
    },
    rightNext() {
      if (this.isText === '转入') {
        this.$router.push(`/supermarket/v2/EnterAmount?orderId=${this.$router.currentRoute.query.orderId}`);
      } else {
        this.$router.push(`/supermarket/v2/OutAmount?orderId=${this.$router.currentRoute.query.orderId}`);
      }
    },
  },
};
</script>
<style scoped>
.ToIntoFail{
  background: #fff;
}
.TransferFailed_box{
  margin-bottom: 52px;
}
.TransferFailed{
  font-family: PingFangSC-Medium;
  font-size: 17px;
  margin: 9px 0 8px 0;
  color: #1C2438;
}
.TransferFailed_tip{
  font-family: PingFangSC-Regular;
  font-size: 14px;
  color: #9EA7B4;
}
</style>
